{
  "modal": {
    "categoryTierModal": {
      "create": "Create",
      "delete": "Delete",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Description is empty",
      "titleLabel": "Title",
      "titlePlaceholder": "Please enter title...",
      "update": "Update"
    },
    "archiveProject": {
      "title": "Archive project",
      "confirmDescription": "Are you sure you want to archive this project including all its document versions?"
    },
    "infoReaders": {
      "description": "This is a list of users which are as assigned readers of this document, and their status. Only the owner of this document can remove the reader.",
      "title": "Readers Information"
    },
    "inviteUsers": {
      "name": "Name",
      "subText": "Users will get invitations in their emails to read and accept the document.",
      "title": "Invite Users"
    },
    "tags": {
      "manageTags": "Manage tags",
      "newTag": "New tag",
      "selectTag": "Select tag",
      "searchOrCreate": "Search or create tags",
      "existingTags": "Existing tags",
      "searchToFindOrCreate": "Search to find or create tags"
    },
    "removeLinksWarning": {
      "title": "Linked documents will be removed",
      "description": "If you change the Category or Tier of this document, all links to other documents will be removed. Are you sure you want to proceed?",
      "linkedDocumentsRemoval": "The following linked documents will be removed",
      "proceed": "Proceed"
    },
    "reviewSchedule": {
      "startDate": "Start Date",
      "dueDate": "Due Date",
      "recurringPeriod": "Recurring Period"
    },
    "editDocumentTitle": {
      "placeholder": "Enter new title",
      "duplicateWarning": "There already is a document named"
    },
    "officeDesktop": {
      "trackChangesDisabledTitle": "Track changes is not enabled.",
      "trackChangesDisabledDescription": "Enable track changes to ensure changes are visible.",
      "cancel": "Cancel"
    }
  }
}
